// Copyright 2025-2026 - Hewlett Packard Enterprise Company

import { useContext } from 'react';
import { Box } from 'grommet';

import { SidebarContext } from '../../providers/SidebarProvider';
import { ChatProvider } from '../../providers/ChatProvider';
import ChatContainer from '../Chat/ChatContainer';
import Help from '../Help/Help';

export default function SidebarContent({ width, ...rest }) {
  const { isChatOpen, setIsChatOpen, isInsightsOpen, setInsightsPortalNode } =
    useContext(SidebarContext);

  return (
    <ChatProvider>
      <Box border="left" width={width} fill overflow="auto" {...rest}>
        {isChatOpen && <ChatContainer onClose={setIsChatOpen} />}
        {isInsightsOpen && <Box ref={setInsightsPortalNode} fill />}
        <Help width={width} />
      </Box>
    </ChatProvider>
  );
}
